import { render, staticRenderFns } from "./FilesClosed.vue?vue&type=template&id=2df21ba0"
import script from "./FilesClosed.vue?vue&type=script&lang=js"
export * from "./FilesClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports